<template>
  <modal
    name="alert"
    height="auto"
    draggable=".draggable"
    :click-to-close="false"
    :reset="true"
    transition="nice-modal-fade"
  >
    <v-card class="draggable">
      <v-card-title :class="`${themeColor} white--text`">
        <v-icon large dark>
          {{ icon }}
        </v-icon>
        <div class="ml-2" />
        {{ title }}
      </v-card-title>
      <!-- eslint-disable-next-line -->
      <v-card-text class="mt-2 text-center font-weight-black" style="color: black" v-html="text" />

      <v-divider style="border-color: gray" />

      <v-card-actions>
        <v-spacer />
        <v-btn :color="themeColor" text @click="close()"> ตกลง </v-btn>
      </v-card-actions>
    </v-card>
  </modal>
</template>

<script>
import Vue from "vue"
export default Vue.extend({
  name: "AlertBox",
  data() {
    return {
      alert: false,
      title: "",
      text: "",
      typeAlertBox: "",
      resolve: null,
    }
  },
  computed: {
    themeColor() {
      if (this.typeAlertBox === "info") return "primary"
      if (this.typeAlertBox === "success") return this.typeAlertBox
      if (this.typeAlertBox === "warning") return this.typeAlertBox
      if (this.typeAlertBox === "error") return this.typeAlertBox

      return "success"
    },
    icon() {
      if (this.typeAlertBox === "info") return "mdi-information"
      if (this.typeAlertBox === "success") return "mdi-check-circle"
      if (this.typeAlertBox === "warning") return "mdi-alert"
      if (this.typeAlertBox === "error") return "mdi-alert-circle"

      return "check_circle"
    },
  },
  methods: {
    close() {
      this.resolve({ status: "close" })
      // this.alert = false
      this.$modal.hide("alert")
    },
    showAlert(text, typeAlertBox = null, title = null) {
      this.title = title || ""
      this.text = text
      this.typeAlertBox = typeAlertBox || "success"
      // this.alert = true
      this.$modal.show("alert")
      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    },
  },
})
</script>
